import { z } from 'zod'

export const CRM_TESTING_SEED_CONTRACT_VERSION = '1.0.0' as const

export const crmTestingSeedResponseSchema = z.object({
  contract_version: z.literal(CRM_TESTING_SEED_CONTRACT_VERSION),
}).passthrough()

export const crmTestingSeedCleanupResponseSchema = crmTestingSeedResponseSchema

export type CrmTestingSeedResponse = z.infer<typeof crmTestingSeedResponseSchema>
export type CrmTestingSeedCleanupResponse = z.infer<typeof crmTestingSeedCleanupResponseSchema>
